/**
 * @generated SignedSource<<3f4c16a3e93d4b385871559c59579801>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useTicketDetailLookupByIdQuery$variables = {
  id: string;
};
export type useTicketDetailLookupByIdQuery$data = {
  readonly viewer: {
    readonly ticketDetail: {
      readonly ticket: {
        readonly id: string;
        readonly slug: string;
      };
    } | null;
  } | null;
};
export type useTicketDetailLookupByIdQuery = {
  variables: useTicketDetailLookupByIdQuery$variables;
  response: useTicketDetailLookupByIdQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": [
    {
      "kind": "Variable",
      "name": "id",
      "variableName": "id"
    }
  ],
  "concreteType": "TicketDetail",
  "kind": "LinkedField",
  "name": "ticketDetail",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Ticket",
      "kind": "LinkedField",
      "name": "ticket",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "slug",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useTicketDetailLookupByIdQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useTicketDetailLookupByIdQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c37181d914c226ce235b7e3ab671691f",
    "id": null,
    "metadata": {},
    "name": "useTicketDetailLookupByIdQuery",
    "operationKind": "query",
    "text": "query useTicketDetailLookupByIdQuery(\n  $id: ID!\n) {\n  viewer {\n    ticketDetail(id: $id) {\n      ticket {\n        id\n        slug\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "e9022280642f1a589501316d09c81fe7";

export default node;
